import Vue                    from 'vue';
import Vuetify                from 'vuetify/lib';
import fr                     from 'vuetify/src/locale/fr';

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: {
    scrollBarWidth: 6,
    thresholds: {
      xs: 600,
      sm: 992,
      md: 1024,
      lg: 1920,
    },
  },
  theme: {
    options: {
      customProperties: false,
      minifyTheme: function (css) {
        return process.env.NODE_ENV === 'production' ? css.replace(/[\r\n|\r|\n]/g, '') : css;
      },
    },
    themes: {
      light: {
        base: '#fff', // smoke white
        main: '#2e2d2d', // smoke gray
        primary: '#d4d4d4', // gray
        secondary: '#676889', // dark lila
        tertiary: '#1e9eb2', // turquoise
        accent: '#ed466b', // coral
        warning: '#fca425', // deep yellow
        error: '#a9103a', // deep coral
        info: '#00bddb', // light turquoise
        disabled: '#bdbdbd' // light gray
      },
      dark: {
        base: '#121212', // darken gray
        main: '#b7b7b7', //  deep gray
        primary: '#1d1d1d', // dark
        secondary: '#9FA8DA', // light lila
        tertiary: '#b7b7b7', // gray
        accent: '#1e9eb2', // turquoise
        warning: '#fca425', // deep yellow
        error: '#a9103a', // deep coral
        info: '#80DEEA', // light cian
        disabled: '#bdbdbd' // light gray
      },
    },
  },
  lang: {
    locales: { fr },
    current: 'fr',
  },
});
